<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name" v-validate="'required|max:100'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>
              </div>
              <div class="col-md-12">
                <v-select data-vv-as="estilo" label="Estilo en el organigrama*" name="style" v-model="item.style" v-validate="'required'" :items="NODE_STYLES" item-text="name" item-value="id" :disabled="isViewModal()">
                  <template v-slot:item="{ item: style }">
                    <span class="oc-swatch mr-3" :class="style.id"></span>{{ style.name }}
                  </template>
                  <template v-slot:selection="{ item: style }">
                    <span class="oc-swatch mr-3" :class="style.id"></span>{{ style.name }}
                  </template>
                </v-select>
                <span class="red--text">{{ errors.first("style") }}</span>
                <div class="text-caption grey--text text--darken-1">Los estilos Oscuro y Medio muestran además la cantidad de legajos.</div>
              </div>
              <div class="col-md-12">
                <v-text-field data-vv-as="orden" label="Orden" name="sort_order" type="number" v-model="item.sort_order" v-validate="'integer'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("sort_order") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { NODE_STYLES } from "@/constants/org_chart";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      NODE_STYLES: NODE_STYLES,
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (!valid) return;
        e.preventDefault();

        this.loading = true;
        const data = {
          id: this.item.id,
          name: this.item.name,
          style: this.item.style,
          sort_order: this.item.sort_order !== "" && this.item.sort_order != null ? parseInt(this.item.sort_order) : null,
        };

        const is_update = this.item.id > 0;
        const request = is_update ? this.service.update(data) : this.service.create(data);
        request
          .then((response) => {
            if (response.status) {
              this.$toast.success("El " + this.modal_title + (is_update ? " se modifico correctamente." : " se creo correctamente."), "OK");
              this.$emit("updateDialog", false);
              this.$emit("loadList");
            } else {
              this.$toast.error(response.message || response.msg, "Error");
            }
          })
          .catch((response) => {
            console.log(response);
            this.$toast.error(response.msg, "Error");
          })
          .finally(() => (this.loading = false));
      });
    },
  },
};
</script>
